<div class="container-fluid">
  <app-pagetitle title="FILEUPLOAD" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
</div>
<div class="main-card-container">
  <div class="card">
    <div class="card-body">
      <div class="dropzone" dnd (fileDropped)="onFileListDropped($event)">
        <input type="file" #uploadFileDropRef id="uploadFileDrop" multiple 
          (change)="uploadHandler($event.target.files)"
        />
        <div class="fileU">
          <i class="mdi mdi-file-upload" style=""></i>
        </div>
       
        <h3>Drag and Drop files here</h3>
        <h3>or</h3>
        <label for="uploadFileDrop">Browse</label>
      </div>
      <div class="fileListoCntainer">
        <ul class="fileList">
          <li class="fileItem" *ngFor="let file of files; let i = index">
            <i class="mdi mdi-file-document font-size-18" ngbTooltip="File upload icon"></i>
            <div class="info">
              <h4 class="name">{{file?.name}}</h4>
              <div class="size">{{ formatBytes(file?.size)}}</div>
              <!-- <app-progress [progress]="file?.progress"></app-progress> -->
            </div>
            <i class="mdi mdi-trash-can font-size-18"  (click)="onDelete(i)"ngbTooltip="Delete"></i>
          </li>
        </ul>
      </div>
      <button type="submit" class="btn btn-primary" (click)="onSubmit()"ngbTooltip="Submit">Submit</button>
    </div>
  </div>
</div>